export class AssignmentQuestionsWorkedOn {
  constructor(
    public threeMonth: number | undefined,
    public oneMonth: number | undefined,
    public nineMonth: number | undefined,
    public thisYear: number | undefined,
    public sixMonth: number | undefined,
    public eighteenMonth: number | undefined,
    public twelveMonth: number | undefined,
  ) {}
}
